/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsHashtag: {
  name: 'hashtag';
  data: string;
} = {
  name: 'hashtag',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 .5a.5.5 0 0 1 .5.5v3.5H15a.5.5 0 0 1 0 1h-3.5v5H15a.5.5 0 0 1 0 1h-3.5V15a.5.5 0 0 1-1 0v-3.5h-5V15a.5.5 0 0 1-1 0v-3.5H1a.5.5 0 0 1 0-1h3.5v-5H1a.5.5 0 0 1 0-1h3.5V1a.5.5 0 0 1 1 0v3.5h5V1a.5.5 0 0 1 .5-.5Zm-5.5 5v5h5v-5h-5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
